const DASHBOARD2_APP_PARENT_SELECTOR = '[data-testid="app-parent"]';

const DEFAULT_SCHEDULE_PANEL_SCROLL_OFFSET_PX = 12;

/** Scrolls the dashboard2 app shell so the schedule panel sits near the top. */
export function scrollDashboard2SchedulePanelIntoView(
  anchor: HTMLElement | null,
  options?: { offsetPx?: number }
): void {
  if (!anchor) {
    return;
  }

  const offsetPx = options?.offsetPx ?? DEFAULT_SCHEDULE_PANEL_SCROLL_OFFSET_PX;
  const scrollContainer = document.querySelector<HTMLElement>(DASHBOARD2_APP_PARENT_SELECTOR);

  if (!scrollContainer) {
    anchor.scrollIntoView({ behavior: "smooth", block: "start" });
    return;
  }

  const containerRect = scrollContainer.getBoundingClientRect();
  const anchorRect = anchor.getBoundingClientRect();
  const nextTop = scrollContainer.scrollTop + (anchorRect.top - containerRect.top) - offsetPx;

  scrollContainer.scrollTo({
    top: Math.max(0, nextTop),
    behavior: "smooth"
  });
}
